"use client";

import { SiteLink } from "@i18n/SiteLink";
import { Button } from "@ui/components/button";
import type { ReactNode } from "react";

interface ProductCTAProps {
	title: string;
	description: string;
	cta: {
		primary: {
			text: string;
			href: string;
			icon?: ReactNode;
		};
		secondary: {
			text: string;
			href: string;
			isExternal?: boolean;
		};
	};
	features?: string;
	className?: string;
}

export function ProductCTA({
	title,
	description,
	cta,
	features,
	className,
}: ProductCTAProps) {
	return (
		<div className={`py-16 ${className || ""}`}>
			<div className="container mx-auto px-4">
				<div className="text-center max-w-3xl mx-auto">
					<h2 className="text-3xl lg:text-4xl font-bold mb-6">
						{title}
					</h2>
					<p className="text-xl text-muted-foreground mb-8">
						{description}
					</p>

					<div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
						<Button size="lg" variant="primary" asChild>
							<SiteLink href={cta.primary.href}>
								{cta.primary.text}
								{cta.primary.icon}
							</SiteLink>
						</Button>

						<Button asChild variant="outline" size="lg">
							{cta.secondary.isExternal ? (
								<a
									href={cta.secondary.href}
									target="_blank"
									rel="noopener noreferrer"
								>
									{cta.secondary.text}
								</a>
							) : (
								<SiteLink href={cta.secondary.href}>
									{cta.secondary.text}
								</SiteLink>
							)}
						</Button>
					</div>

					{features && (
						<p className="text-sm text-muted-foreground">
							{features}
						</p>
					)}
				</div>
			</div>
		</div>
	);
}
